import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getToken } from '../../utils/sessionManagement'
import { useLocation } from 'react-router-dom'

// handle the private routes
const PrivateRoutes = () => {
  const location = useLocation()

  if (!getToken()) {
    // Stockez le chemin d'origine dans le local storage
    localStorage.setItem('redirectPath', location.pathname + location.search)
    return <Navigate to="/login" />
  }

  return <Outlet />
}
export default PrivateRoutes
